import { api } from "../scripts/api.js";

const I = {
   classes: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><line x1="4" y1="7" x2="20" y2="7"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="17" x2="20" y2="17"/></svg>`,
   scoreboard: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>`,
   export: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 4v12"/><path d="M7 11l5 5 5-5"/><path d="M4 20h16"/></svg>`,
   activity: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 12h4l2 6 4-14 2 8h6"/></svg>`,
   engagement: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>`,
   roles: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 3l7 3v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V6z"/></svg>`,
   scores: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M4 19V5"/><rect x="7" y="10" width="3" height="9"/><rect x="12" y="6" width="3" height="13"/><rect x="17" y="13" width="3" height="6"/></svg>`,
   convert: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 16V4"/><path d="M8 8l4-4 4 4"/><path d="M4 20h16"/></svg>`,
   assignments: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8"/><path d="M8 12h8"/><path d="M8 16h5"/></svg>`,
   games: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2"/><path d="M9 2h6"/></svg>`,
   training: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 4l9 4-9 4-9-4z"/><path d="M6 10.5V16c0 1.4 2.7 2.8 6 2.8s6-1.4 6-2.8v-5.5"/></svg>`,
   modules: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="3" y="3" width="8" height="8" rx="1.5"/><rect x="13" y="3" width="8" height="8" rx="1.5"/><rect x="3" y="13" width="8" height="8" rx="1.5"/><path d="M17 14v6"/><path d="M14 17h6"/></svg>`,
   profile: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg>`,
   onboard: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="9" cy="8" r="3.5"/><path d="M3 20c0-3.3 2.7-5 6-5s6 1.7 6 5"/><path d="M18 8v6"/><path d="M15 11h6"/></svg>`,
   signout: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><path d="M10 17l5-5-5-5"/><path d="M15 12H3"/></svg>`,
   guide: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M4 5a2 2 0 0 1 2-2h11v18H6a2 2 0 0 1-2-2z"/><path d="M17 3h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-1"/><path d="M8 8h5"/><path d="M8 12h5"/></svg>`,
   settings: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1"/></svg>`,
   reports: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 3l9 16H3z"/><path d="M12 9v4"/><path d="M12 16h.01"/></svg>`,
   xp: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 3l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.6 6.6 19.5l1.2-6L3.3 9.3l6.1-.7z"/></svg>`,
   createAssignment: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/><path d="M14 3v5h5"/><path d="M12 11v6"/><path d="M9 14h6"/></svg>`,
};

/*
   Menu differs by role.

   NOTE ON THE GUIDE LINKS: guide.html and setup.html are STATIC pages, not hash
   views, so they leave the app rather than routing within it. That works here
   without any special-casing because both pieces of link handling key on "#":
     - the click handler below reads href.indexOf("#") and returns early at -1,
       so the browser navigates normally instead of setting location.hash
     - markActive() resolves its hash to "" and never marks it active
   Do NOT give either a data-view; there is no component behind them.

   TWO AUDIENCES, TWO PAGES. guide.html is written for instructors (classes,
   assignments, modules, scoreboard) and stays off the student menu. setup.html
   is the student one (installing the add-in, signing in, troubleshooting), so
   students get "Setup guide" instead.

   Both were reachable ONLY from access.html until 2026-08-29, so a signed-in
   user had no route to either from anywhere in the portal.
*/
const MENU = {
   student: [
      { href: "student.html#classes", label: "Classes", icon: I.classes },
      { href: "student.html#score", label: "My scores", icon: I.scores },
      { href: "student.html#my-time", label: "My time", icon: I.scores },
      // My XP (2026-10-22): hidden until /me/xp/classes confirms a Game Launcher class,
      // so a student in FIN 413 only never sees a page with nothing on it. See revealXp().
      { href: "student.html#xp", label: "My XP", icon: I.xp, conditional: true },
      // Static published coursework, identical for every student, so unlike
      // Class standings below it is NOT conditional - there is no class flag to
      // check and nothing that can 403.
      { href: "student.html#training", label: "Training", icon: I.training },
      // The case library lives under Training but has its own view, because it
      // FETCHES per-student state. A student whose classes all have it off gets
      // a plain explanation on the page rather than a hidden menu item: the
      // 404 that says "no access" is indistinguishable from a broken link if
      // the item simply disappears.
      { href: "student.html#library", label: "Case library", icon: I.training },
      // Rendered hidden and revealed only if one of this student's classes has a
      // board switched on. See revealClassBoards() below - the default is hidden,
      // so a fetch that fails leaves the item away rather than offering a link
      // that 403s.
      { href: "student.html#class-boards", label: "Class standings", icon: I.scoreboard, conditional: true },
      // TA tools (2026-09-16). Hidden unless one of this person's classes seats
      // them as a TA AND lets TAs run games. See revealTaTools() below.
      { href: "student.html#games", label: "Run games", icon: I.games, conditional: true },
      { href: "setup.html", label: "Setup guide", icon: I.guide },
   ],
   professor: [
      { href: "professor.html#classes", label: "Classes", icon: I.classes },
      { href: "professor.html#scoreboard", label: "Scoreboard", icon: I.scoreboard },
      { href: "professor.html#assignments", label: "Assignments", icon: I.assignments },
      { href: "professor.html#modules", label: "Modules", icon: I.modules },
      { href: "professor.html#library", label: "Case library", icon: I.training },
      { href: "professor.html#skill-map", label: "Skill map", icon: I.training },
      { href: "professor.html#class-readiness", label: "Team readiness", icon: I.scoreboard },
      { href: "professor.html#games", label: "Games", icon: I.games },
      { href: "professor.html#scores", label: "Scores", icon: I.scores },
      { href: "professor.html#export", label: "Export Grades", icon: I.export },
      { href: "professor.html#activity", label: "Activity", icon: I.activity },
      { href: "professor.html#engagement", label: "Engagement", icon: I.engagement },
      { href: "professor.html#engagement-weekly", label: "Engagement by week", icon: I.engagement },
      { href: "professor.html#convert", label: "Convert", icon: I.convert },
      { href: "professor.html#reports", label: "Problem reports", icon: I.reports },
      { href: "guide.html", label: "User Guides", icon: I.guide },
   ],
   admin: [
      { href: "admin.html#classes", label: "Classes", icon: I.classes },
      { href: "admin.html#scoreboard", label: "Scoreboard", icon: I.scoreboard },
      { href: "admin.html#assignments", label: "Assignments", icon: I.assignments },
      { href: "admin.html#modules", label: "Modules", icon: I.modules },
      { href: "admin.html#library", label: "Case library", icon: I.training },
      { href: "admin.html#skill-map", label: "Skill map", icon: I.training },
      { href: "admin.html#class-readiness", label: "Team readiness", icon: I.scoreboard },
      { href: "admin.html#games", label: "Games", icon: I.games },
      { href: "admin.html#scores", label: "Scores", icon: I.scores },
      { href: "admin.html#export", label: "Export Grades", icon: I.export },
      { href: "admin.html#activity", label: "Activity", icon: I.activity },
      { href: "admin.html#engagement", label: "Engagement", icon: I.engagement },
      { href: "admin.html#engagement-weekly", label: "Engagement by week", icon: I.engagement },
      { href: "admin.html#create-assignment", label: "Create Assignment", icon: I.createAssignment },
      { href: "admin.html#roles", label: "Roles & Access", icon: I.roles },
      { href: "admin.html#access", label: "Training access", icon: I.training },
      { href: "admin.html#onboard", label: "Onboard user", icon: I.onboard },
      { href: "admin.html#convert", label: "Convert", icon: I.convert },
      { href: "admin.html#reports", label: "Problem reports", icon: I.reports },
      { href: "admin.html#pane-settings", label: "Pane settings", icon: I.settings },
      { href: "guide.html", label: "User Guides", icon: I.guide },
   ],
};

function linkHTML(m) {
   const badge = m.badge ? `<span class="nav-badge">${m.badge}</span>` : "";
   const hidden = m.conditional ? " hidden" : "";
   return `<a class="navlink" href="${m.href}"${hidden}>${m.icon}<span>${m.label}</span>${badge}</a>`;
}

class AppMenu extends HTMLElement {
   connectedCallback() {
      const role = this.getAttribute("role") || "student";
      const links = (MENU[role] || []).map(linkHTML).join("");
      const page = role === "admin" ? "admin.html"
            : role === "professor" ? "professor.html"
            : "student.html";

      this.innerHTML = `
            <aside class="sidebar">
               <div class="side-label">Menu</div>
               <nav class="sidebar-nav">${links}</nav>

               <div class="side-label">Account</div>
               <nav class="sidebar-nav">
                  <a class="navlink" href="${page}#profile">${I.profile}<span>My Profile</span></a>
                  <button class="navlink signout" id="btn-logout">${I.signout}<span>Sign out</span></button>
               </nav>
            </aside>
         `;
      
      this.querySelector("#btn-logout").addEventListener("click", logout);
      if (role === "student") {
         this.revealClassBoards();
         this.revealTaTools();
         this.revealXp();
      }
      if (!location.hash) {
         location.hash = "#classes";
      } else {
         this.markActive();
      }

      // Update the hash without the browser's scoll jump
      this.querySelectorAll(".navlink[href]").forEach((a) => {
         a.addEventListener("click", (e) => {
            const href = a.getAttribute("href");
            const hashIndex = href.indexOf("#");
            if (hashIndex === -1) return;
            const linkPage = href.slice(0, hashIndex).replace(/\.html$/, "");
            const herePage = location.pathname.split("/").pop().replace(/\.html$/, "");
            if (linkPage === herePage || linkPage === "") {
               e.preventDefault();
               location.hash = href.slice(hashIndex);
            }
         });
      });
      
      window.addEventListener("hashchange", () => this.markActive());
   }
   /*
      Class standings is only a real destination when a professor has switched a
      board on, so the link starts hidden and is revealed only once /me confirms
      at least one enrolled class allows one. Hidden-by-default, revealed-on-
      confirmation (rather than shown-then-removed) means a slow or failed /me
      leaves a student with a menu that works instead of one that flashes a link
      and then takes it away.

      This is presentation only. The server decides access; the menu just avoids
      offering a door that is locked.
   */
   async revealClassBoards() {
      try {
         const res = await api("/me");
         if (!res.ok) return;
         const me = await res.json();
         const anyOpen = (me.classes || []).some(
            (c) => c.students_see_scoreboard || c.students_see_engagement
         );
         if (!anyOpen) return;
         const link = this.querySelector('.navlink[href$="#class-boards"]');
         if (link) link.hidden = false;
      } catch {
         /* leave it hidden */
      }
   }

   /*
      Same hidden-until-confirmed rule as Class standings, for a student who is a
      TA somewhere. /list-classes returns only the classes this person teaches or
      TAs (an empty list for an ordinary student), each with my_role and the
      class's ta_permissions. Presentation only; the game routes re-check.
   */
   async revealTaTools() {
      try {
         const res = await api("/list-classes");
         if (!res.ok) return;
         const data = await res.json();
         const canRun = (data.classes || []).some(
            (c) => c.my_role === "ta" && c.ta_permissions && c.ta_permissions.run_games
         );
         if (!canRun) return;
         const link = this.querySelector('.navlink[href$="#games"]');
         if (link) link.hidden = false;
      } catch {
         /* leave it hidden */
      }
   }

   /* My XP: same hidden-until-confirmed rule, for a student in a Game Launcher class. */
   async revealXp() {
      try {
         const res = await api("/me/xp/classes");
         if (!res.ok) return;
         const data = await res.json();
         if (!(data.classes || []).length) return;
         const link = this.querySelector('.navlink[href$="#xp"]');
         if (link) link.hidden = false;
      } catch {
         /* leave it hidden */
      }
   }

   markActive() {
      const here = location.hash;
      this.querySelectorAll(".navlink").forEach((a) => {
         const href = a.getAttribute("href");
         if (!href) return;
         const i = href.indexOf("#");
         const hash = i === -1 ? "" : href.slice(i);
         a.classList.toggle("on", hash !== "" && (hash === here || (hash === "#xp" && here.startsWith("#xp/"))));
      });
   }
}
customElements.define("app-menu", AppMenu);

async function logout() {
   await api(`/auth/logout`, { method: "POST" });
   location.href = "/web.html";
}